import React, { Component } from 'react';
import { get } from 'lodash';

import Modal from 'widgets/Modal/Modal';

import FoodProfileStep1 from './FoodProfileStep1';
import FoodProfileStep2 from './FoodProfileStep2';
import FoodProfileStep3 from './FoodProfileStep3';
import FoodProfileFailed from './FoodProfileFailed';
import FoodProfileSuccess from './FoodProfileSuccess';
import FoodProfilePopupEdit from './FoodProfilePopupEdit';
import { setProfileCondition } from 'apps/foodProfile/utils';

export default class FoodProfilePopup extends Component {
  static getDerivedStateFromProps(props, state) {
    /*
    refresh profile values in state every time popup is open
    because they may be changed on Settings page
    */
    if (props.isPopupOpened !== state.isPopupOpened) {
      return {
        isPopupOpened: props.isPopupOpened,
        profile: props.profile || [{
          Conditions: props.conditions,
        }],
      };
    }
    return null;
  }

  state = {
    isPopupOpened: this.props.isPopupOpened,
    profile: this.props.profile || [{
      Conditions: this.props.conditions,
    }],
  };

  onChange = (ConditionID, ConditionSelected) => {
    const profile = this.state.profile[0];
    const updatedProfile = setProfileCondition(profile, ConditionID, ConditionSelected);
    this.setState({ profile: [updatedProfile] });
  }

  createFoodProfile = () => {
    this.props.createFoodProfile(this.state.profile[0])
      .then(
        () => this.props.setFoodProfilePopupStep(4),
        () => this.props.setFoodProfilePopupStep(3),
      );
  }

  updateProfile = () => {
    this.props.persistFoodProfile(this.state.profile[0])
      .then(
        () => this.props.setFoodProfilePopupStep(4),
        () => this.props.setFoodProfilePopupStep(3),
      );
  }

  renderStepOne = () => (
    <FoodProfileStep1
      nextStepHandler={() => this.props.setFoodProfilePopupStep(1)}
      closeHandler={this.props.toggleFoodProfilePopup}
    />
  );

  renderStepTwo = () => (
    <FoodProfileStep2
      values={get(this.state.profile, ['0', 'Conditions'], [])}
      conditions={this.props.conditions}
      onChange={this.onChange}
      nextStepHandler={() => this.props.setFoodProfilePopupStep(2)}
      closeHandler={this.props.toggleFoodProfilePopup}
    />
  );

  renderStepThree = () => (
    <FoodProfileStep3
      nextStepHandler={this.createFoodProfile}
      closeHandler={this.props.toggleFoodProfilePopup}
    />
  );

  renderStepFail = () => (
    <FoodProfileFailed
      closeHandler={this.props.toggleFoodProfilePopup}
    />
  );

  renderStepSuccess = () => (
    <FoodProfileSuccess
      closeHandler={this.props.toggleFoodProfilePopup}
    />
  );

  renderEditProfile = () => (
    <FoodProfilePopupEdit
      values={get(this.state.profile, ['0', 'Conditions'], [])}
      conditions={this.props.conditions}
      onChange={this.onChange}
      nextStepHandler={this.updateProfile}
      closeHandler={this.props.toggleFoodProfilePopup}
    />
  );

  render() {
    const {
      isPopupOpened,
      currentStep,
    } = this.props;
    const stepRenderers = [
      this.renderStepOne,
      this.renderStepTwo,
      this.renderStepThree,
      this.renderStepFail,
      this.renderStepSuccess,
      this.renderEditProfile,
    ];
    const stepRenderer = (currentStep >= 0 && currentStep <= 5) ? stepRenderers[currentStep]() : null;

    return (isPopupOpened &&
      <Modal
        className="js-foodProfilePopup"
        onCancel={this.props.toggleFoodProfilePopup}
      >
        {stepRenderer}
      </Modal>
    );
  }
}
